/**
 * `result` shows action results and hides them after a while
 *
 *
 * ## usage
 * ```html
 * <result [status]='status' ></result>
 * ```
 */
import { Directive } from '@angular/core';
import { NgInject } from '@df/ng/ng-inject';
import { ActionComponentDef } from '@df/ui/api/action.component.def';
import { NoticeService } from '@df/ui/api/notice/notice.service';

@Directive()
export class ResultComponentDef extends ActionComponentDef {
    @NgInject(NoticeService)
    protected noticeService!: NoticeService;

    public message?: string;

    /**
     * Toggle element visibility and set result message
     */
    protected override onUpdate() {
        const msg = this.isResultVisible ? this.getMessage() : '';
        this.message = msg;
        this.renderer.setClass(this.ngEl.nativeElement, 'hidden', !msg);
    }

    protected getMessage(): string {
        return this.noticeService.transform(this._status?.result || '', this.success) || '';
    }
}
